import localeAntd from 'ant-design-vue/lib/locale-provider/es_ES'

const messages = {
  topBar: {
    issuesHistory: 'Issues History',
    projectManagement: 'Gestión del sistema',
    typeToSearch: 'Buscar...',
    findPages: 'Buscar páginas ...',
    actions: 'Actions',
    status: 'Status',
    profileMenu: {
      hello: 'Hola',
      billingPlan: 'Billing Plan',
      role: 'Rol',
      email: 'Email',
      phone: 'Phone',
      editProfile: 'Configuración del Perfil',
      logout: 'Cerrar sesión',
    },
  },
}

export default {
  locale: 'es-ES',
  localeAntd,
  messages,
}
